import { APP_NAME } from "consts"

export const setDocumentTitle = title => {
  document.title = `${title} | ${APP_NAME}`
}
